/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, c as createEvent, h } from './index-ef0fa435.js';
import { D as DoorState } from './sliding-door-interface-7c209a7c.js';

const slidingDoorCss = "";

const RadioButtonContent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.sendcommand = createEvent(this, "sendcommand", 7);
    this.color = undefined;
    this.doorState = undefined;
    this.stopEnabled = undefined;
    this.loading = undefined;
  }
  render() {
    return (h("lar-button-group", null, h("lar-button", { disabled: this.loading || this.doorState === DoorState.OPEN || this.doorState === DoorState.OPENING || this.doorState === DoorState.CLOSING, color: this.color, onClick: () => this.sendcommand.emit('open') }, h("lar-translate", { t: "slidingDoor.open" })), h("lar-button", { disabled: this.loading || this.doorState === DoorState.CLOSED || this.doorState === DoorState.OPENING || this.doorState === DoorState.CLOSING, color: this.color, onClick: () => this.sendcommand.emit('close') }, h("lar-translate", { t: "slidingDoor.close" })), this.stopEnabled === true ?
      h("lar-button", { disabled: this.loading || (this.doorState !== DoorState.OPENING && this.doorState !== DoorState.CLOSING), color: this.color, onClick: () => this.sendcommand.emit('stop') }, h("lar-translate", { t: "slidingDoor.stop" })) : null));
  }
};
RadioButtonContent.style = slidingDoorCss;

export { RadioButtonContent as sliding_door_content };

//# sourceMappingURL=sliding-door-content.entry.js.map